import { DropdownDivider, DropdownItem } from 'bold-ui'
import { DropdownButton } from 'components/dropdown'
import React from 'react'

interface AtividadeColetivaGruposTableDropdownMenuProps {
  readonly onExcluir: () => void
}

export function AtividadeColetivaGruposTableDropdownMenu(props: AtividadeColetivaGruposTableDropdownMenuProps) {
  const { onExcluir } = props

  return (
    <DropdownButton>
      <DropdownItem>Editar grupo</DropdownItem>
      <DropdownItem>Inativar grupo</DropdownItem>
      <DropdownDivider />
      <DropdownItem type='danger' onClick={onExcluir}>
        Excluir grupo
      </DropdownItem>
    </DropdownButton>
  )
}
